/**
 * Check if value is a function
 * @param {*} value The value to check
 * @returns {boolean} True if the value is a function, otherwise false
 */
export const isFunction = (value) =>
	typeof value === 'function';

/**
 * Value to value matcher, using tuples.
 * @param {*} value Value to match
 * @param {[Array]} matchers Tuples of value and result
 * @param {function(*): *} fallback Fallback called if no match is found
 * @param {function(*, *): boolean} [compare=(a, b) => a === b] Function to compare values, defaults to strict equality
 * @returns {*} The matched result or the fallback result if no match is found
 * @example
 * const result = mx(
 * 	'foo',
 * 	[
 * 		['foo', 'bar'],
 * 		['bar', 'foo'],
 * 	],
 * 	() => 'baz',
 * )
 * // result === 'bar'
 */
export const match = (value, matchers, fallback, compare = (a, b) => a === b) => {
	const match = matchers.find(([matcher]) => compare(value, matcher))
	if (match) {
		const result = match[1]
		if (isFunction(result)) {
			return result(value)
		}
		return result
	}

	return fallback(value)
};



// WEBPACK FOOTER //
// ./src/components/utils/match.js